export default __webpack_public_path__ + "static/kyber-swap-7f1492a8b298b461e56592c0aa7e5bf9.png";